import { render, staticRenderFns } from "./AddPaper.vue?vue&type=template&id=a48aab20&scoped=true"
import script from "./AddPaper.vue?vue&type=script&lang=js"
export * from "./AddPaper.vue?vue&type=script&lang=js"
import style0 from "./AddPaper.vue?vue&type=style&index=0&id=a48aab20&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48aab20",
  null
  
)

export default component.exports